import { render, staticRenderFns } from "./OtherStep.vue?vue&type=template&id=32ad2b72&scoped=true&"
import script from "./OtherStep.vue?vue&type=script&lang=ts&"
export * from "./OtherStep.vue?vue&type=script&lang=ts&"
import style0 from "./OtherStep.vue?vue&type=style&index=0&id=32ad2b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad2b72",
  null
  
)

export default component.exports